import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getDocumentTypes(): Promise<any> {
  return await axiosInstance.get('/document-types', getDefaultRequestConfig());
}
